import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles/SectionAccordion.module.css";
import { Accordion } from "react-bootstrap";
import { UnitItem } from "./UnitItem";
import { useEffect } from "react";

const SectionAccordion = (props) => {
  const { data: section, onChange, currentLesson } = props;
  // state
  const [activeKey, setActiveKey] = useState();

  // variables

  // logics before hooks

  // hooks

  // logics
  const toggleAccordion = () => {
    if (activeKey) {
      setActiveKey(null);
    } else {
      setActiveKey(section.id);
    }
  };

  const checkLessonInSection = () => {
    if (!section || !currentLesson) return false;
    for (let i = 0; i < section.lessons.length; i++) {
      if (section.lessons[i].id === currentLesson.id) return true;
    }
    return false;
  };

  // UI partials

  // effects
  useEffect(() => {
    if (section && checkLessonInSection()) {
      setActiveKey(section.id);
    }
  }, [currentLesson]);

  // render
  return (
    <Accordion
      key={section.id}
      className={styles.accordionContainer}
      //   defaultActiveKey={section.id}
      activeKey={activeKey}
    >
      <Accordion.Item eventKey={section.id}>
        <Accordion.Header
          className={styles.accordionHeader}
          onClick={() => toggleAccordion()}
        >
          {section.title}
        </Accordion.Header>
        <Accordion.Body className={styles.accordionBody}>
          {section.lessons.map((lesson) => {
            return (
              <UnitItem
                key={lesson.id}
                data={lesson}
                onChange={onChange}
                currentLesson={currentLesson}
              />
            );
          })}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

/* required: display name */
SectionAccordion.displayName = "SectionAccordion";

/* required: props types */
SectionAccordion.propTypes = {
  data: PropTypes.object,
  onChange: PropTypes.func,
  currentLesson: PropTypes.object,
};

/* required: default props */
SectionAccordion.defaultProps = {};

export { SectionAccordion };
